<template>
  <div class="main user-layout-register">
    <a-descriptions
      :title="list[0].dictLabel"
      :column="4"
    ></a-descriptions>
    <div>
      <a-checkbox-group
        v-model="checkedList"
        :options="options"
      />
      <div class="row_z">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="原价">
                <a-input
                  v-model="originalPrice"
                  placeholder="请输入"
                  allow-clear
                  disabled
                  oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="价格">
                <a-input
                  v-model="price"
                  placeholder="请输入"
                  disabled
                  oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="时长">
                <a-input
                  v-model="time"
                  disabled
                  placeholder="请输入"
                  allow-clear
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div style="margin-bottom:30px">
        <a-button
          type="primary"
          @click="handleSubmit"
        >
          提交
        </a-button>
      </div>
    </div>
    <a-descriptions
      :title="list[1].dictLabel"
      :column="4"
    ></a-descriptions>
    <div>
      <a-checkbox-group
        v-model="checkedList1"
        :options="options"
      />
      <div class="row_z">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="原价">
                <a-input
                  v-model="originalPrice1"
                  placeholder="请输入"
                  disabled
                  oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="价格">
                <a-input
                  v-model="price1"
                  placeholder="请输入"
                  allow-clear
                  disabled
                  oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="时长">
                <a-input
                  v-model="time1"
                  placeholder="请输入"
                  allow-clear
                  disabled
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div>
        <a-button
          type="primary"
          @click="handleSubmits"
        >
          提交
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDev, controlPublic, devDetail, subDate, modeType, controlM1, controlM2 } from '@/api/device'
let client = null
export default {
  name: 'Register',
  // components: { videoPlayer },
  data () {
    return {
      devId: '',
      info: {},
      list: [],
      immGetPub05: {},
      immGetPub06: {},
      devInfo: {},
      checkedList: [],
      checkedList1: [],
      time1: '',
      time: '',
      originalPrice: '',
      originalPrice1: '',
      price: '',
      price1: '',
      options: [
        { label: '预充', value: 1 },
        { label: '低泡', value: 2 },
        { label: '冲水1', value: 3 },
        { label: '高泡', value: 4 },
        { label: '冲水2', value: 5 },
        { label: '冲水3', value: 6 },
        { label: '水蜡', value: 7 },
        { label: '风干', value: 8 },
      ]
    }
  },
  computed: {},
  created () {
    let index = window.location.href.indexOf('id=')
    // console.log(window.location.href.substring(index + 3), '大大大大大')
    this.devId = window.location.href.substring(index + 3)
    console.log(this.devId, 'this.devId this.devId ');
    // 查询详情
    this.getDetail()
    this.getDevDetail()
    modeType().then(res => {
      console.log('洗车模式', res)
      this.list = res.data
    })
  },
  beforeDestroy () {
    client.end()
  },
  methods: {
    getDetail () {
      getDev({ devId: this.devId }).then(res => {
        res = res.data
        console.log(res, '滴滴滴滴滴滴1111');
        this.info = res
        this.immGetPub05 = res.immGetPub05
        res.m1.split(',').forEach(v => {
          // v = Number(v)
          this.checkedList.push(Number(v))
        })
        this.checkedList1 = res.m2.split(',')
        res.m2.split(',').forEach(v => {
          // v = Number(v)
          this.checkedList1.push(Number(v))
        })
        console.log(this.checkedList, 'this.checkedList');
        console.log(this.checkedList1, 'this.checkedList');
        // console.log(this.immGetPub05, '滴滴滴滴滴滴1111');
        // this.immGetPub06 = res.immGetPub06
      })
    },
    // 提交数据
    handleSubmit () {
      console.log(this.checkedList, 'this.checkedListthis.checkedList');
      if (this.checkedList.length == 0) return this.$message.error('请选择' + this.list[0].dictValue)
      if (!this.originalPrice) return this.$message.error('请输入原价')
      console.log('测试', this.checkedList.length, this.originalPrice)
      if (!this.price) return this.$message.error('请输入价格')
      if (!this.time) return this.$message.error('请输入时长')
      let m1 = this.checkedList.join(',')
      console.log(this.originalPrice, 'this.originalPricethis.originalPrice');
      controlM1({ m1, originalPrice: this.originalPrice, price: this.price, time: this.time, devId: this.devId }).then(res => {
        this.$message.success('提交成功')
      })
    },
    // 提交数据
    handleSubmits () {
      if (this.checkedList1.length == 0) return this.$message.error('请选择' + this.list[0].dictValue)
      if (!this.originalPrice1) return this.$message.error('请输入原价')
      if (!this.price1) return this.$message.error('请输入价格')
      let m2 = this.checkedList1.join(',')
      controlM2({ m2, originalPrice: this.originalPrice1, price: this.price1, time: this.time1, devId: this.devId }).then(res => {
        this.$message.success('提交成功')
      })
    },
    getDevDetail () {
      devDetail({ id: this.devId }).then(res => {
        res = res.data
        this.devInfo = res
        console.log(res, 'devInfodevInfodevInfodevInfo');
        let mode = res.devModeList
        if (mode && mode.length) {
          this.originalPrice = mode[0].originalPrice
          this.price = mode[0].price
          this.time = mode[0].duration
          if (mode.length == 2) {
            this.originalPrice1 = mode[1].originalPrice
            this.price1 = mode[1].price
            this.time1 = mode[1].duration
          }
        }

        // this.subscribe = res.devCode + '/immGetSub01'
        this.subscribe = [res.devCode + '/web/pub/01', res.devCode + '/web/pub/02']
        console.log(this.subscribe, 'this.subscribethis.subscribethis.subscribe');
        this.connectMqtt()
      })
    },
    /**
 * @desc mqtt连接
 * @author 刘
 * @time 2023年06月02日 18:31:19 星期五
 */
    connectMqtt () {
      const that = this
      var mqtt = require('mqtt/dist/mqtt.js')
      // client = mqtt.connect('ws://emqx.zzcyi.cn:8083/bao/bao-dev')
      // const mqttUrl = 'ws://139.196.79.66:7084/bao/bao-dev'
      const mqttUrl = 'ws://139.196.79.66:7084/mqtt'
      // client = mqtt.connect('ws://47.104.102.88:8083/bao/bao-dev')
      client = mqtt.connect(mqttUrl, {
        protocolVersion: 4,
        reconnectPeriod: 100,
        connectTimeout: 30 * 1000,
        resubscribe: true,
        keepalive: 3,
        clientId:
          'mqttjs_' +
          Math.random()
            .toString(16)
            .substr(2, 8)
      })
      client.on('connect', function () {
        console.log('on connect', new Date().getTime())
        console.log('主题>>>>', that.subscribe)
        client.subscribe(that.subscribe, function (err, granted) {
          console.log('订阅主题>>>>>err>>>>', err, that.subscribe)
          console.log('订阅主题>>>>>granted>>>>', granted)
          if (!err) {
            console.log('订阅成功>>>>')
          }
        })
      }).on('reconnect', function () {
        // uni.showLoading({
        // 	title:'加载中...',
        // 	mask:true
        // })
        // setTimeout(function() {
        // 	uni.hideLoading()
        // }, 3000);
        console.log('重新连接', new Date().getTime())
      }).on('close', function (err) {
        // that.setIsMqttConnect(false)
        console.log('链接断开>>>>', err)
      }).on('error', function (err) {
        console.log('on error', err)
      }).on('end', function () {
        // that.setIsMqttConnect(false)
        console.log('on end')
      }).on('message', function (topic, message) {
        console.log('mqtt消息', message.toString())
        // alert(message.toString())
        // that.getDetail()
        let num = JSON.parse(message.toString());
        console.log(num, 'numnumnumnum====');
        if (num.topic.indexOf('/web/pub/05') !== -1) {
          that.immGetPub05 = num
          that.$forceUpdate()
          // console.log(that.immGetPub01, 'that.immGetPub01that.immGetPub01');
        } else if (num.topic.indexOf('/web/pub/06') !== -1) {
          that.immGetPub06 = num
          that.$forceUpdate()
          // console.log(that.immGetPub02, 'that.immGetimmGetPub02immGetPub02immGetPub02Pub01that.immGetPub01');
        }
        // try {
        //   const messageObj = JSON.parse(message)
        //   console.log('接受到的消息>>>', messageObj)
        //   // logType为"sendToDev"--向设备发送信息
        //   // logType为"devReply"--设备回复
        //   // logType为"devLogin"--设备上线
        //   that.setData(messageObj)
        // } catch (e) {
        //   // TODO handle the exception
        // }
      })
    },
    // 点击控制
    handleControl (e, url) {
      console.log(e, '滴滴滴滴滴滴');

      let that = this
      console.log(that.devId, ' that.devId that.devId');
      this.$confirm({
        title: '提示',
        content: e,
        onOk () {
          controlPublic(url, { devId: that.devId }).then(res => {

          })
        },
        onCancel () { },
      });
    },
    submit () {
      console.log(1111);
    },
    // 点击长按事件
    handleDown (e, url) {
      // 设置一个定时器，如果用户持续按住，则执行长按操作
      if (!this.open) return this.$message.error('请检查现场情况在打开锁')
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null
      }
      this.longPressTimer = setTimeout(() => {
        // 执行长按后的操作
        // console.log('Long press triggered');
        this[e] = true
        if (e == 's3' || e == 's4' || e == 's5' || e == 's6') {
          // s3 向前 后 正 反
          controlPublics(url, { id: this.devId, open: true }).then(res => {

          })
        } else if (e == 's1') {
          // s1 升 
          controlPublic(url, { devId: this.devId, YCMSS: true }).then(res => {

          })
        } else {
          // s2 降
          controlPublic(url, { devId: this.devId, YCMXJ: true }).then(res => {

          })
        }
        // if (e == 1) {
        //   console.log(this.s1, '对对对的多多多急急急吗');
        // }
        // clearTimeout(this.longPressTimer);

      }, 800); // 长按1秒
    },
    // 结束长按
    handleUp (e, url) {
      console.log('handleUp>>>>');
      if (!this.open) return
      // 清除定时器
      clearTimeout(this.longPressTimer);
      // if (e == 1) {
      //   this.s1 = false
      // }
      if (!this[e]) return
      this[e] = false
      if (e == 's3' || e == 's4' || e == 's5' || e == 's6') {
        // s3 向前 后 正 反
        controlPublics(url, { id: this.devId, open: false }).then(res => {
        })
      } else if (e == 's1') {
        // s1 升 
        controlPublic(url, { devId: this.devId, YCMSS: false }).then(res => {

        })
      } else {
        // s2 降
        controlPublic(url, { devId: this.devId, YCMXJ: false }).then(res => {

        })
      }
      this.longPressActive = false
    },
  }
}
</script>

<style lang="less" scoped>
.main {
  height: 80vh;

  .row_z {
    margin: 10px 0;
  }
}
</style>
